import store from '../store';

/**
 * Loads all the organisation required data defined on the loadingData variable.
 * @returns {Promise} Combined promise for all the requests.
 */
async function loadOrganisationData() {
  const errors = [];
  const loadingData = [
    {
      name: 'chat/fetchQuickReplies',
      payload: null,
      message: 'Loading organisation data...',
      callback: () => { },
    },
    {
      name: 'contact/fetchCustomFields20',
      payload: null,
      message: 'Loading organisation data...',
      callback: () => { },
    },
  ];

  const requests = [];

  loadingData.forEach((action) => {
    if (action.initial !== false) { // add check in the store
      const request = store.dispatch(action.name, action.payload);
      request
        .then(action.callback)
        .catch(error => errors.push(error.message));

      requests.push(request);
    }
  });

  return Promise.all(requests).then(() => { });
}

function updateOrganisationData() { }

export { loadOrganisationData, updateOrganisationData };
